import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Upload,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/th';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import './index.css';
import styles from './index.module.scss';
import ProfileMenu from '../../../components/ProfileMenu';
import { getLocalUrl } from '../../../functions';
import Layout from '../../../layouts/User';
import OverwriteMomentBE from '../../../services/picker/OverwriteMomentBE';

import { createTheme } from '@material-ui/core/styles';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { MuiPickersOverrides } from '@material-ui/pickers/typings/overrides';
import { ThemeProvider } from '@material-ui/styles';
import { getStates } from '../../../services/api';

type overridesNameToClassKey = {
  [P in keyof MuiPickersOverrides]: keyof MuiPickersOverrides[P];
};
declare module '@material-ui/core/styles/overrides' {
  export interface ComponentNameToClassKey extends overridesNameToClassKey {}
}

const Home: React.FC = () => {
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [genderOptions, setGenderOptions] = useState<any>([]);
  const [profileImage, setProfileImage] = useState<any>('');
  const [profile, setProfile] = useState<any>('');
  const [profileName, setProfileName] = useState<any>('');
  const [newImage, setNewImage] = useState<any>({});
  const [selectedDate, setSelectedDate] = useState<any>(
    moment().add(0, 'year')
  );
  const [states, setStates] = useState<any>();

  let [formProfile] = Form.useForm();
  const { Option } = Select;
  const breadcrumbs = [
    {
      text: 'หน้าหลัก',
      path: '/',
    },
    {
      text: 'ข้อมูลของฉัน',
    },
  ];

  const dateFormat = 'DD/MM/YYYY';

  const confirmButton = async (values: any) => {
    const xdate = {
      ...values,
      birthDate: selectedDate.utcOffset(0, true),
      scgId: currentUser.scgFamily?.scgId,
    };
    const fmData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    if (newImage.uid) {
      fmData.append('file', newImage);
      await axios.post(
        `/users/upload-profile/${currentUser._id}`,
        fmData,
        config
      );
    }
    await axios.patch(`/users/${currentUser._id}`, xdate);
    window.location.reload();
  };

  const onPreview = (file: any) => {
    const url = getLocalUrl(file?.originFileObj);
    window.open(url, '_blank');
  };

  const onUploadChange = (file: any) => {
    setProfile('');
    if (file.file.status !== 'done') return;

    setProfile(file?.file?.thumbUrl);
    setNewImage(file.file.originFileObj);
  };

  const getState = async () => {
    setStates(await getStates());
    return;
  };

  const getGenderOptions = async () => {
    const genders = await axios.get(`/sexes`);
    const options: JSX.Element[] = [];
    // for (let i = 0; i < genders?.data?.data?.length; i++) {
    //   options.push(
    //     <Option value={genders?.data?.data[i]?._id} key={genders?.data?.data[i]?._id}>
    //       {genders?.data?.data[i]?.name}
    //     </Option>
    //   );
    // }
    genders?.data?.data?.forEach((gender: any) => {
      options.push(
        <Option value={gender._id} key={gender._id}>
          {gender.name}
        </Option>
      );
    });

    setGenderOptions(options);
  };

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    getGenderOptions();
    getState();
    setSelectedDate(moment(currentUser?.birthDate, dateFormat));
    formProfile.setFieldsValue({
      ...currentUser,
      sex: currentUser.sex?._id,
      birthDate: moment(currentUser?.birthDate, dateFormat),
      imageProfile: [
        {
          name: 'image.png',
          status: 'done',
          url: `${currentUser.photoURL}`,
        },
      ],
    });
  }, [currentUser]);

  const uploadButton = (
    <div>
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const theme = createTheme({
    overrides: {
      MuiButton: {
        textPrimary: {
          color: '#2d6fa5',
        },
      },
      MuiPickersDay: {
        day: {
          color: 'black',
        },
        daySelected: {
          backgroundColor: '#2d6fa5',
          '&:hover': {
            backgroundColor: '#2d6fa5',
          },
        },
        dayDisabled: {
          color: '#ccc',
        },
        current: {
          color: '#2d6fa5',
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#2d6fa5',
        },
      },
    },
  });

  return (
    <>
      <div>
        <Form form={formProfile} onFinish={confirmButton} layout='vertical'>
          <Row>
            <div className={styles.header}>ข้อมูลของฉัน</div>
            <Divider
              style={{ background: 'black', margin: '15px 0' }}
            ></Divider>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className='mb-3 pl-5 pr-5 upload-container'
            >
              <div className={styles.textCenter}>
                <Upload
                  multiple={false}
                  customRequest={({ onSuccess }: any) => {
                    onSuccess();
                  }}
                  onChange={(e) => onUploadChange(e)}
                  style={{ height: '85px' }}
                  maxCount={1}
                  listType='picture-card'
                  showUploadList={true}
                  className={[styles.uploadDocument, styles.textCenter].join(
                    ' '
                  )}
                  onPreview={onPreview}
                >
                  {profile ? (
                    <img src={profile} alt='avatar' style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`displayName`}
                label={`ชื่อที่แสดง`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Input name='displayName' placeholder='ชื่อที่แสดง' />
              </Form.Item>
            </Col>
            <Col span={24} className={`${styles.field}`}>
              <h2>ข้อมูลส่วนตัว</h2>
              <Divider
                style={{ background: 'black', margin: '15px 0' }}
              ></Divider>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`firstName`}
                label={`ชื่อ`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Input name='firstName' placeholder='ชื่อ' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`lastName`}
                label={`นามสกุล`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Input name='lastName' placeholder='นามสกุล' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`email`}
                label={`อีเมล์`}
                rules={[
                  {
                    validator: async (_, value) => {
                      const result = String(value)
                        .toLowerCase()
                        .match(
                          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        );

                      if (!(result && result.length)) {
                        return Promise.reject(
                          new Error('กรุณากรอกอีเมลให้ถูกต้อง!')
                        );
                      }
                    },
                  },
                ]}
              >
                <Input name='email' placeholder='อีเมล์' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`phone`}
                label={`โทรศัพท์`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                  {
                    validator: async (_, value) => {
                      if (value && value.length !== 10) {
                        return Promise.reject(new Error('กรุณาป้อน 10 หลัก!'));
                      }
                    },
                  },
                ]}
              >
                <Input min={0} max={10} name='phone' placeholder='โทรศัพท์' />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`sex`}
                label={`เพศ`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select placeholder='เพศ'>{genderOptions}</Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`birthDate`}
                label={`วัน/เดือน/ปี เกิด`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <ThemeProvider theme={theme}>
                  <MuiPickersUtilsProvider
                    utils={OverwriteMomentBE}
                    locale='th'
                  >
                    <React.Fragment>
                      <DatePicker
                        openTo='year'
                        className={`${styles.DatePicker}`}
                        style={{ padding: '0px 0px 0px 0px' }}
                        format='DD/MM/yyyy'
                        views={['year', 'month', 'date']}
                        value={selectedDate}
                        onChange={() => setSelectedDate(selectedDate)}
                      />
                    </React.Fragment>
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} className={`${styles.field}`}>
              <Form.Item
                name={`currentState`}
                label={`จังหวัดที่ท่านอาศัยอยู่ปัจจุบัน`}
                rules={[
                  {
                    required: true,
                    message: 'กรุณากรอกข้อมูล!',
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption={(input, option: any) =>
                    option.label.indexOf(input.toLowerCase()) >= 0
                  }
                  options={states}
                  placeholder='จังหวัด'
                ></Select>
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field}`}
            >
              <Form.Item
                      label='ช่าง หรือ เจ้าของบ้าน'
                      name='position'
                      rules={[
                        {
                          required: true,
                          message: 'กรุณเลือกช่าง หรือ เจ้าของบ้าน!',
                        },
                      ]}
                    >
                      <Select
                        placeholder='ช่าง หรือ เจ้าของบ้าน'
                      >
                        <Option value='technician'>ช่าง</Option>
                        <Option value='house_owner'>เจ้าของบ้าน</Option>
                      </Select>
                    </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field}`}
            ></Col>
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              className={`${styles.field} ${styles.right}`}
            >
              <Button htmlType='submit' className={`${styles.confirmButton}`}>
                บันทึก
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default Home;
